import React, { useState } from 'react';

import {Button, Modal, Form, Alert } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import Dialog from '../../services/Dialogs'

const ModalCambiarMetas = ( params : any ) => {

  const { show, handleClose, meta_real, setMetaReal, meta_fake_asesor, setMetaFakeAsesor, meta_fake_gerente, setMetaFakeGerente } = params

  const dialog = new Dialog();

  const [ meta_real_, setMetaReal_ ] = useState<boolean>(meta_real)

  // const [ meta_fake_asesor_, setMetaFakeAsesor_ ] = useState(4)
  // const [ meta_fake_gerente_, setMetaFakeGerente_ ] = useState(1)

const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){

        setMetaReal(meta_real_)
        setMetaFakeGerente(registro.meta_fake_gerente_)
        setMetaFakeAsesor(registro.meta_fake_asesor_)
        handleClose()
        
      }
     
}


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({

          meta_fake_asesor_ : yup.number().required(mensajes_validacion_generico),
          meta_fake_gerente_ : yup.number().required(mensajes_validacion_generico),

  });


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Cambiar las Metas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // meta_real_ ? 'SI' : 'No'
          }

      <Form.Check // prettier-ignore
        type="switch"
        checked={meta_real_}
        onChange={(e:any)=>{setMetaReal_(e.target.checked)}}
        id="custom-switch"
        label="Mostrar la Meta Real"
      />



    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{
            meta_fake_asesor_ : meta_fake_asesor,
            meta_fake_gerente_ : meta_fake_gerente,
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>

        {
          !meta_real_ && (

            <>

        <Alert key={0} variant={"danger"} className="mt-4">
          Ahora puede asignar las metas para asignarlas manualmente
        </Alert>

               <div className="row mt-2">
                <div className="col-6">
                    <Form.Group   className="mb-3" controlId="meta_fake_asesor_">
                      <Form.Label>Meta por Asesor</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="meta_fake_asesor_"
                        value={values.meta_fake_asesor_}
                        onChange={(e)=>{ setFieldValue('meta_fake_asesor_', e.target.value ) }}
                        isInvalid={!!errors.meta_fake_asesor_}
                      />
                      <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>

                </div>
                <div className="col-6">
                    <Form.Group   className="mb-3" controlId="meta_fake_gerente_">
                      <Form.Label>Meta por Gerente</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="meta_fake_gerente_"
                        value={values.meta_fake_gerente_}
                        onChange={(e)=>{ setFieldValue('meta_fake_gerente_', e.target.value ) }}
                        isInvalid={!!errors.meta_fake_gerente_}
                      />
                      <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>

                </div>
              </div>



            </>

          )
        }


        {
          meta_real_ && (

            <>

                <Alert key={0} variant={"primary"} className="mt-4">
                  Las metas asignadas para cada Asesor y Gerente aplican para este reporte
                </Alert>

            </>

          )
        }



        </Form>
      )}
    </Formik>







        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalCambiarMetas;